//** Component  */
import React from "react";

//** Lib */
 

 
import ImageManagementList from "./ImageManagementList";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";


function ImageManagement() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.IMAGEMANAGEMENTOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.IMAGEMANAGEMENTARCHIVETAB);
  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: < ImageManagementList openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <ImageManagementList openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];
  return (
    <>
       <CustomTab data={data} />
    </>
  );
}

export default ImageManagement;
